import {DataGrid, GridColumnSettings} from "../../../common";
import useActivityLogList from "./useActivityLogList";
import {Chip} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";


export default function ActivityLog() {
  const columnSettings: GridColumnSettings = {
    related_table: {
      renderCell: params => {
        return (
          <>{params.row.related_table}</>
        );
      }
    }
  };
  const {grid} = useActivityLogList();

  return (
    <DataGrid
      {...grid}
      modalProps={{
        maxWidth: "md",
      }}
      columnSettings={columnSettings}
      headerItems={["search", "refresh"]}
      canDelete={false}
      canView={false}
    />
  );
}